import { POST,postFile } from "../../index";
export const queryInstructList = (param) => POST("/v1/IssuedController/queryInstructList", param);
export const addBriefnessInstruct = (param) => postFile("/v1/IssuedController/addBriefnessInstruct", param);
export const addComplexInstruct = (param) => postFile("/v1/IssuedController/addComplexInstruct", param);
export const reTry = (param) => POST("/v1/IssuedController/reTry", param);
export const cancel = (param) => POST("/v1/IssuedController/cancel", param);
export const queryByType = (param) => POST("/v1/AliKeyController/queryByType", param);
export const exportTerminalId = (param) => postFile("/getCameraListExcel/exportTerminalId", param);
